/**
 * Brand the Shopify Inbox chat activator button only.
 * Scoped to shopify-chat / ShopifyChat hosts (including shadow DOM).
 */
(function () {
  var BG = '#bc2126';
  var FG = '#ffffff';
  var STYLE_ID = 'rr-shopify-chat-brand';
  var STYLE_TEXT =
    'button.activator{' +
      '--activator-fg:' +
      FG +
      ';--activator-bg:' +
      BG +
      ';background-color:' +
      BG +
      '!important;background:' +
      BG +
      '!important;color:' +
      FG +
      '!important;border-color:' +
      BG +
      '!important;' +
      '}' +
      'button.activator .activator__label{' +
      'color:' +
      FG +
      '!important;' +
      '}' +
      'button.activator svg,button.activator svg path{' +
      'fill:' +
      FG +
      '!important;stroke:' +
      FG +
      '!important;color:' +
      FG +
      '!important;' +
      '}';

  function injectStyle(root) {
    if (!root || root.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = STYLE_TEXT;
    root.appendChild(style);
  }

  function styleActivator(btn) {
    if (!btn || btn.tagName !== 'BUTTON' || !btn.classList.contains('activator')) return;
    btn.style.setProperty('--activator-fg', FG);
    btn.style.setProperty('--activator-bg', BG);
    btn.style.setProperty('background-color', BG, 'important');
    btn.style.setProperty('background', BG, 'important');
    btn.style.setProperty('color', FG, 'important');
    btn.style.setProperty('border-color', BG, 'important');
    btn.querySelectorAll('.activator__label').forEach(function (el) {
      el.style.setProperty('color', FG, 'important');
    });
    btn.querySelectorAll('svg, path').forEach(function (el) {
      el.style.setProperty('fill', FG, 'important');
      el.style.setProperty('stroke', FG, 'important');
    });
  }

  function scanHost(host) {
    if (!host) return;
    if (host.shadowRoot) {
      injectStyle(host.shadowRoot);
      host.shadowRoot.querySelectorAll('button.activator').forEach(styleActivator);
    }
    host.querySelectorAll('button.activator').forEach(styleActivator);
  }

  function scan() {
    document.querySelectorAll('#shopify-chat, shopify-chat, #ShopifyChat').forEach(scanHost);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  try {
    new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}
})();
